import { useState } from 'react';

const navLinks = [
  { label: 'HOME', href: '#hero' },
  { label: 'SHOWROOM', href: '#showroom' },
  { label: 'SERVICES', href: '#projects' },
  { label: 'PROCESS', href: '#meeting' },
  { label: 'CONTACT', href: '#contact' },
];

const LOGO_URL = 'https://storage.readdy-site.link/project_files/c43d99a8-1e00-428b-96a3-32143e86ff11/bcf6558c-e91e-4119-a12c-9be3fc757e38_LOGO-02.png?v=3a69170f5d332829f533c4be3357c7ec';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      className="fixed top-0 left-0 w-full z-50"
      style={{ backgroundColor: '#143C3C', height: '72px', borderBottom: 'none' }}
    >
      <div
        className="h-full flex items-center justify-between"
        style={{ padding: '0 60px' }}
      >
        {/* Logo — desktop */}
        <a
          href="#hero"
          onClick={(e) => { e.preventDefault(); handleNav('#hero'); }}
          className="hidden md:flex flex-shrink-0 cursor-pointer items-center"
        >
          <img
            src={LOGO_URL}
            alt="Barkfy Logo"
            style={{ width: '160px', height: 'auto' }}
            className="object-contain"
          />
        </a>

        {/* Logo — mobile (centered) */}
        <a
          href="#hero"
          onClick={(e) => { e.preventDefault(); handleNav('#hero'); }}
          className="md:hidden absolute left-1/2 -translate-x-1/2 cursor-pointer"
        >
          <img
            src={LOGO_URL}
            alt="Barkfy Logo"
            style={{ width: '120px', height: 'auto' }}
            className="object-contain"
          />
        </a>

        {/* Desktop nav links */}
        <ul className="hidden md:flex items-center" style={{ gap: '40px' }}>
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                className="transition-colors duration-200 cursor-pointer whitespace-nowrap no-underline"
                style={{
                  fontSize: '14px',
                  color: '#FFFFFF',
                  letterSpacing: '0.08em',
                  fontWeight: 500,
                  textDecoration: 'none',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.color = '#DC5014')}
                onMouseLeave={(e) => (e.currentTarget.style.color = '#FFFFFF')}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        {/* CTA button — desktop */}
        <a
          href="#contact"
          onClick={(e) => { e.preventDefault(); handleNav('#contact'); }}
          className="hidden md:block font-bold cursor-pointer whitespace-nowrap transition-colors duration-200"
          style={{
            backgroundColor: '#DC5014',
            color: '#FFFFFF',
            padding: '12px 28px',
            borderRadius: '4px',
            fontSize: '14px',
            letterSpacing: '0.05em',
            textDecoration: 'none',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#BF4411')}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#DC5014')}
        >
          GET A QUOTE
        </a>

        {/* Hamburger — mobile */}
        <button
          className="md:hidden text-2xl w-8 h-8 flex items-center justify-center cursor-pointer bg-transparent border-0"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={menuOpen ? 'ri-close-line' : 'ri-menu-3-line'} style={{ color: '#FFFFFF' }} />
        </button>
      </div>

      {/* Mobile dropdown menu */}
      {menuOpen && (
        <div
          className="md:hidden flex flex-col gap-5 px-6 py-6 border-t"
          style={{ backgroundColor: '#143C3C', borderColor: 'rgba(255,255,255,0.15)' }}
        >
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
              className="cursor-pointer whitespace-nowrap no-underline"
              style={{
                fontSize: '13px',
                color: '#FFFFFF',
                letterSpacing: '0.08em',
                textDecoration: 'none',
              }}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); handleNav('#contact'); }}
            className="font-bold text-white text-center cursor-pointer whitespace-nowrap"
            style={{
              backgroundColor: '#DC5014',
              padding: '12px 28px',
              borderRadius: '4px',
              fontSize: '14px',
              textDecoration: 'none',
            }}
          >
            GET A QUOTE
          </a>
        </div>
      )}
    </nav>
  );
}
